module.exports = __webpack_public_path__ + "img/pride-display.b6cb28a2.png";